import { trpcClient } from '@framework/trpcClient';
import { useEffect, useState } from 'react';

export const TestHelloPage: React.FC = () => {
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchMessage = async () => {
      try {
        const { message } = await trpcClient.hello.query();
        setMessage(message);
      } catch (error) {
        console.error('Failed to fetch message:', error);
        setMessage(`Failed to fetch message: ${error}`);
      }
    };
    fetchMessage();
  }, []);

  return <div>message: {message}</div>;
};
